import { Injectable } from '@angular/core';
import { HeadersService } from '../../shared/utilities/HeadersService';
import { IntegrationService } from '../../shared/services/integration.service';
import { Observable } from 'rxjs';
import { BaseRestService } from '../../shared/services/BaseRestService';
import { JsonApiWrap} from '../../shared/models/JsonApiWrap';
import { Preference } from '../models/Preference';
import { PreferenceTab } from '../models/PreferenceTab';

@Injectable({
  providedIn: 'root'
})
export class UserPreferenceService {
  statusViewExperiencePath: string = 'api/ria.MoneyMovementStatusviewExperience';

  constructor(
    private readonly headersService: HeadersService,
    private readonly integrationService: IntegrationService,
    private baseService: BaseRestService

  ) { }

  getUserPreference(): Observable<Preference[]> {
    const headers = this.headersService.createHeadersWithJsonApiContentSharedToken();
    const url = `${this.integrationService.JfkEnv.BaseUrl}${this.statusViewExperiencePath}/v1/SavePreferences`;
    return this.baseService.requestJsonApiList(url, headers, null, 'GET');
  }

  saveUserPreference(requestData: PreferenceTab): Observable<Preference[]> {
    const headers = this.headersService.createHeadersWithJsonApiContentSharedToken();
    const url = `${this.integrationService.JfkEnv.BaseUrl}${this.statusViewExperiencePath}/v1/SavePreferences`;
    let preference: Preference = {
      preferenceGroupName: 'sac.movemoney',
      preferenceName: requestData.tableName + '-' + requestData.tabName,
      preferenceValue: JSON.stringify(requestData.columns)
    }
    let requestBody: JsonApiWrap<Preference> = {
      data: {
        attributes: preference,
        type: 'preferences',
        id: ''
      }
    }
    return this.baseService.requestJsonApiList<Preference, Preference>(
      url,
      headers,
      requestBody,
      'POST'
    );
  }

}
